import React from 'react';

import PropTypes from 'prop-types';
import { MdAdd, MdRemove } from 'react-icons/md';
import styled from 'styled-components';

const ToggleIconFLPlus = styled.span`
  font-size: 1.25rem;
  padding-left: 0.5rem;
`;

function BrandedToggleIcon({ open, name }) {
  return (
    <ToggleIconFLPlus>
      {open ? (
        <MdRemove aria-hidden="true" data-autotag={`filter-${name}-collapse`} />
      ) : (
        <MdAdd aria-hidden="true" data-autotag={`filter-${name}-expand`} />
      )}
    </ToggleIconFLPlus>
  );
}

BrandedToggleIcon.propTypes = {
  name: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};
export default BrandedToggleIcon;
